<template>
  <div class="partner_box body-box ">
    <div class="div-img-top body-width divcss5 partner_font">
      <div class="font_zh">
        {{$t("cooperation.partner")}}
      </div>
      <div class="font_en font_en_top">
        COOPERATIVE PARTNER
      </div>
    </div>
    <div class="parter_body" style="padding-left: 20px">
      <cooperationcontent></cooperationcontent>
    </div>
  </div>
</template>

<script>
  import cooperationcontent from "@/components/contentcoms/cooperationcontentcoms/cooperationcontent";
  export default {
    name: "partnerpartcontent",
    components: {cooperationcontent}
  }
</script>

<style scoped>
  .partner_font{
    margin-bottom: 40px;
  }
  .font_zh{
    font-size: 24px;
    color: #0D3E88;
    text-align: center;
  }
  .font_en{
    font-size: 16px;
    color: #2E79BE;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/indexcontentcoms/partnerpartcontent.vue